export default __webpack_public_path__ + "static/453-14b273cc1b88555aa3c7e26f58de38eb.gif";